import { LinearProgress } from '@mui/material'

export default function FieldUpdatingIndicator() {
  return (
    <div style={{ height: 0, transform: 'translateY(-2px)' }}>
      <LinearProgress sx={{ height: 2 }} />
    </div>
  )
}
